// removed by extract-text-webpack-plugin
module.exports = {"dashboard":"HomeView__dashboard___1CWb6","calendar":"HomeView__calendar___LqNRo"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/components/HomeView.scss
// module id = 1211
// module chunks = 1